<app-header></app-header>
<section id="esg-blq1" class="bg-dark reset-section-pad2" *ngIf="isDataLoaded">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

        <div class="row">
            <app-title-section class="light" [titleTxt]="esgData.titleTxt">
            </app-title-section>
        </div>

        <div class="row equipo-int-blq">

            <div class="col-lg-12 equipo-int-blq-inner-img">
                <img alt="" class="img-fluid" src="https://{{esgData.imgBigUrl}}" [alt]="esgData.imgBigAlt">
                <div class="int-showcase__footer bg-dark"></div>
            </div>

            <div class="col-lg-8 mt-5 equipo-int-blq-inner-text">

                <p class="light" [innerHTML]="esgData.mainText"></p>

            </div> `
        </div>
    </div>

</section>

<section id="esg-blq7" class="bg-grey">

    <div class="container">


        <div class="row">

            <div class="col-lg-12 esg-blq7-inner">
                <h1 class="fw-bolder">estamos en el<br>camino sostenible</h1>

            </div>

        </div>

        <div class="row">
            <div class="col-lg-12 esg-blq7-content mt-lg-0 mt-4" data-aos="zoom-in-up" data-aos-duration="1500">
                <div class="col-lg-6 col-md-12 pe-lg-4 pe-0 mb-lg-0 mb-3">

                    <p>En RetailCo estamos implicados en el desarrollo de proyectos sostenibles. Nos comprometemos con
                        la
                        <strong>promoción de inmuebles que sean más respetuosos</strong> con el medio ambiente, más
                        eficientes en
                        el uso de recursos naturales y más saludables para sus habitantes. Alineados con este
                        compromiso; nos
                        marcamos como objetivo, la obtención del Certificado LEED para el <strong>emblemático edificio
                            sito en Rúa
                            Policarpo Sanz nº 23, en Vigo</strong>. Gracias a la rehabilitación de esta auténtica joya,
                        contaremos
                        con espacios saludables, eficientes y agradables para sus residentes y vecinos.
                    </p>

                </div>
                <div class="col-lg-6 col-md-12 blq-d ps-lg-4 ps-0">
                    <img class="img-fluid" src="assets/img/policarpo.png"
                        alt="emblemático edificio sito en Rúa Policarpo Sanz nº 23, en Vigo">
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-lg-12 esg-blq7-content" data-aos="zoom-in-up" data-aos-duration="1500">

                <div class="col-lg-6 col-md-12 pe-lg-4 pe-0 order-last order-lg-first">
                    <img class="img-fluid" src="assets/img/leed.png" alt="leed categories">
                    <p class="text-center mt-2">Las puntuaciones obtenidas en los créditos de las diferentes categorías
                        otorgarán una calificación final.</p>
                </div>

                <div class="col-lg-6 col-md-12 ps-lg-4 ps-0 mb-lg-0 mb-4 order-first order-lg-last">
                    <p class="fw-bold">La certificación LEED, voluntaria, está orientada a promover la construcción
                        sostenible e
                        incluye las siguientes mejoras en la construcción:</p>
                    <ul>
                        <li> Sostenibilidad en los materiales y recursos de construcción. </li>
                        <li> Eficiencia y aprovechamiento del agua, tanto durante la construcción del inmueble como
                            durante la
                            fase de operación (reducción de fugas, reducción del consumo, etc). </li>
                        <li> Eficiencia energética. </li>
                        <li> Materiales y recursos sostenibles con el medioambiente. </li>
                        <li> Calidad del ambiente interior. </li>
                        <li> Innovación en el proceso de diseño. </li>
                    </ul>
                </div>

            </div>
        </div>




    </div>

</section>

<section id="esg-blqe2" class="bg-light" *ngIf="isDataLoaded" [style.background-image]="backgroundImageUrl">
    <div class="container">

        <div class="row esg-blq2-inner">
            <div class="col-lg-7 mx-auto">
                <h1 class="fw-bolder light text-center" data-aos="zoom-in-up" data-aos-duration="1500">
                    {{esgData.parallaxText}}</h1>
            </div>
        </div>
    </div>

</section>



<section id="esg-blq4" class="bg-rco" *ngIf="isDataLoaded">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div id="carousel5" class="carousel slide carouselTipo3" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carousel5" data-bs-slide-to="0" class="active"
                            aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carousel5" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>

                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class="col-lg-12 car-t3 mb-5">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-12 car-t3-blq-inner"
                                    [innerHTML]="esgData.carouselText1">
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 col-12 car-t3-blq-inner"
                                    [innerHTML]="esgData.carouselText2">
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 col-12 car-t3-blq-inner"
                                    [innerHTML]="esgData.carouselText3">
                                </div>
                            </div>
                        </div><!-- fin carousel item-->
                        <div class="carousel-item">
                            <div class="col-lg-12 car-t3">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-12 car-t3-blq-inner"
                                    [innerHTML]="esgData.carouselText4">
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 col-12 car-t3-blq-inner"
                                    [innerHTML]="esgData.carouselText5">
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 col-12 car-t3-blq-inner"
                                    [innerHTML]="esgData.carouselText6">
                                </div>
                            </div>
                        </div><!-- fin carousel item-->
                    </div>
                </div>
            </div>
        </div>
    </div><!-- fin container-->
</section>

<section id="esg-blq5" class="section-fluid bg-light" *ngIf="isDataLoaded">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 esg-blq5">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12 esg-blq5-inner">
                    <img alt="" src="https://{{esgData.coverImgUrl}}" [alt]="esgData.coverImgAlt"
                        class="img-full-cover">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12 bg-dark esg-blq5-inner">
                    <p class="light" data-aos="fade-up" data-aos-duration="1500" [innerHTML]="esgData.coverText"></p>
                </div>
            </div>
        </div>
    </div><!-- fin container-->
</section>

<section id="esg-blq6" class="bg-light" *ngIf="isDataLoaded">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 esg-blq6-inner">
                <h1 class="fw-bolder" [innerHTML]="esgData.reclaimTitle"></h1>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 col-md-12" data-aos="zoom-in-up" data-aos-duration="1500">
                <p class="my-lg-4 my-md-2" [innerHTML]="esgData.reclaimText"></p>
                <!-- <a class="btn btn-rco" [routerLink]="mainButtonLink"><p>{{mainButtonText}}</p></a> -->
            </div>
        </div>

    </div><!-- fin container-->
</section>


<app-footer-main></app-footer-main>